import {useTranslation} from "react-i18next";
import VipAdvantage from "./advantages";
import VipFaq from "./vip-faq";
import {useSelector} from "react-redux";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import associateServices from "../../services";
import RankIcon from "../../components/rank-icon";
import Loading from "../../components/loading";
import UserProgress from "../../components/user-progress";
import SvgIcon from "../../components/svg-icon";
import stringHelper from "../../helpers/string-helper";
import store from "../../reducers/createReducers";
import DataActions from "../../actions/data-actions";

const classes = ["ranking--copper", "ranking--platinum", "ranking--diamond", "ranking--obsidian", "ranking--bronze", "ranking--silver", "ranking--gold", "ranking--king"]
const Vip = () => {
    const {vipStatesR} = useSelector(state => state.dataReducer)
    const {authenticated} = useSelector(state => state.authenticationReducer)
    const navigate = useNavigate()
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams()
    const {activeLanguage} = useSelector(state => state.globalReducer)
    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    useEffect(() => {
        if (!loading && (!vipStatesR || !vipStatesR[activeLanguage?.key])) {

            associateServices.getVipStates({
                language: activeLanguage?.key
            }).then(res => {
                const updates = res?.data?.map(i => ({
                    ...i,
                    class: classes[Math.floor(Math.random() * classes.length)]
                })) || []

                store.dispatch(DataActions.setVipStates({
                    data: updates,
                    type: activeLanguage?.key
                }))

                setLoading(false)
            })
        }

    }, [vipStatesR, loading, activeLanguage?.key])

    const handleNavigate = () => {
        if (authenticated)
            navigate(stringHelper.getLocalizedPath(currentLanguage, '/casino/slots'))
        else {

            searchParams.append('modal', 'login')
            setSearchParams(searchParams)
        }
    }


    useEffect(() => {
        try {
            setData(vipStatesR[activeLanguage?.key] || [])
        } catch (e) {

        }
    }, [vipStatesR, activeLanguage?.key])


    return (
        <>

            <div className={`section  ${authenticated ? '' : 'section--first'}`}>
                <div className="container">
                    <div className="row">
                        {
                            authenticated ?
                                <div className="col-12 col-md-4 col-xx-4">
                                    <div className="section section--first">
                                        <UserProgress/>
                                    </div>
                                </div>
                                :
                                <div className="vip">
                                    <h1 className="vip__title">{t('vip.title')}</h1>
                                    <p className="vip__text">
                                        {t('vip.description')}
                                    </p>
                                    <button
                                        onClick={handleNavigate}
                                        className="vip__btn" type="button">
                                        {t('vip.play-now')}
                                    </button>
                                </div>
                        }

                    </div>
                </div>
            </div>
            <div className="section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="section__title section__title--center">
                                {t('vip.ranking-system')}

                            </h2>
                        </div>
                        {
                            loading ? <Loading/> :
                                data?.map(item => (
                                    <div className="col-12 col-md-4 col-xx-4" key={item.icon}>
                                        <div className={`ranking ${item.class} state-slug-${item?.slug}`}>
                                            <div className="d-flex align-items-center justify-content-center gap-2">
                                                {
                                                    item.icon &&
                                                    <RankIcon icon={item.icon}/>
                                                }
                                                <span className="ranking__name">{item.name}</span>
                                            </div>
                                            <span
                                                className="ranking__amount">{Intl.NumberFormat('en', {notation: 'compact'}).format(item.wager_limit || 0)} $</span>
                                            <span className="ranking__wager">{t(`vip.wager-amount`)}</span>
                                            <ul className="ranking__list">
                                                {/*{*/}
                                                {/*    item?.features?.map(opportunity => (*/}
                                                {/*        <li key={opportunity}>*/}
                                                {/*            <SvgIcon id={'info-check'}/>*/}
                                                {/*            {t(`vip.${opportunity}`)}*/}
                                                {/*        </li>*/}
                                                {/*    ))*/}
                                                {/*}*/}

                                                {
                                                    item?.content &&
                                                    <div dangerouslySetInnerHTML={{__html: item.content}}/>
                                                }

                                            </ul>
                                        </div>
                                    </div>
                                ))
                        }
                    </div>
                </div>
            </div>


            {/*<VipAdvantage/>*/}


            <VipFaq/>
        </>

    )

}

export default Vip
